/* @flow */

import React from 'react';
import { Segment, Table, Grid, Button } from 'semantic-ui-react';
import DeploymentItem from './DeploymentItem';
import DeployButton from './DeployButton';

type Props = {
  deployments: Array<CatalogDeployment>,
  onDeployed: () => void,
};

const DeploymentList = ({ deployments, onDeployed }: Props) => (
  <div>
    <Segment color="red">
      <Grid centered columns={2}>
        <Grid.Column textAlign="center">
          <DeployButton
            onDeployed={onDeployed}
            children={onClick => (
              <Button
                onClick={onClick}
                icon="space shuttle"
                color="red"
                labelPosition="left"
                size="big"
                content="Déployer en production"
              />
            )}
          />
        </Grid.Column>
      </Grid>
    </Segment>
    <Segment>
      <Table basic="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2} textAlign="center" />
            <Table.HeaderCell width={7} textAlign="center">
              Date de déploiement
            </Table.HeaderCell>
            <Table.HeaderCell width={7} textAlign="center">
              Utilisateur
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {deployments.map(d => (
            <DeploymentItem key={d.version} deployment={d} />
          ))}
        </Table.Body>
      </Table>
    </Segment>
  </div>
);

export default DeploymentList;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/components/DeploymentList.js